/**
 * Masks a name string for privacy on parent-scope prestay links.
 * Each whitespace-separated part becomes: firstChar + '***' + lastChar.
 * Example: "Antonio Almodóvar" → "A***o A***r"
 *
 * Unicode-safe: uses Array.from() so multi-byte characters count as one unit.
 *
 * @param {string} name
 * @returns {string}
 */
export function maskName(name) {
  if (!name || typeof name !== 'string') return name;
  return name
    .trim()
    .split(' ')
    .filter(Boolean)
    .map(part => {
      const chars = Array.from(part);
      if (chars.length === 1) return `${chars[0]}***${chars[0]}`;
      return `${chars[0]}***${chars[chars.length - 1]}`;
    })
    .join(' ');
}
